// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"On-z","badgeLink":"Pn-z","category":"Qn-z"};